<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,pr_orispeccode,pr_brand"
      placeholder="输入物料编号、名称、型号或厂家/品牌"
      ref="searchBar"
    />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.pr_id + item.wh_code"
        :to="'/stock/query/'+item.pr_id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pr_code }} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.wh_description}}</p>
          <p class="list-item-muted">{{item.pw_onhand}} {{ item.pr_unit }}</p>
        </div>
      </router-link>
    </scroll-list>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/report/ReserveCost/list",
    };
  }
}
</script>